module.exports = __webpack_public_path__ + "static/img/11.1df0766.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/zh/11.png
// module id = NIp0
// module chunks = 0